import React from 'react';
import { APP_TRANSLATIONS } from '../constants/translations';
import { trackSocialClick } from '../analytics';
import { GoogleIcon } from './SocialIcons';
import Tooltip from './Tooltip';

// Google "preferred sources": a reader who stars rivalsbase.com there sees
// more of our articles in Top Stories, Discover and AI answers. Google's
// deeplink instead of its publisher.js button, so no third-party script
// loads on every page. https://developers.google.com/search/docs/appearance/preferred-sources
export const PREFERRED_SOURCE_URL = 'https://www.google.com/preferences/source?q=rivalsbase.com';

// variant 'signoff': one quiet line closing an article, the why written out
// (tooltips don't show on phones). 'compact': the footer pill, with the site
// Tooltip for the why.
export default function PreferredSourceLink({ lang = 'en', variant = 'signoff', placement }) {
  const t = APP_TRANSLATIONS[lang] || APP_TRANSLATIONS.en;
  const linkProps = {
    href: PREFERRED_SOURCE_URL,
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: () => trackSocialClick('google_preferred_source', placement || variant),
  };

  if (variant === 'compact') {
    return (
      <Tooltip label={t.preferredSourceTip}>
        <a
          {...linkProps}
          className="inline-flex min-h-11 items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-ink md:min-h-0 transition-colors hover:border-white/20 hover:bg-white/10 hover:text-white"
        >
          <GoogleIcon size={16} />
          <span>{t.preferredSourceShort}</span>
        </a>
      </Tooltip>
    );
  }

  return (
    <a {...linkProps} className="group flex items-start gap-3 text-sm leading-relaxed text-muted md:items-center">
      <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white">
        <GoogleIcon size={15} />
      </span>
      <span>
        {t.preferredSourceLead}{' '}
        <span className="font-semibold text-cyan-300 underline decoration-cyan-300/40 underline-offset-4 transition-colors group-hover:text-cyan-200 group-hover:decoration-cyan-200">
          {t.preferredSourceAction}
        </span>
      </span>
    </a>
  );
}
